module.exports = __webpack_public_path__ + "assets/MARK_-_Digital_Infrastructure.cb6a9ebe.svg";